'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el, type, callback, capture) {
  var cb = function cb() {
    _event2.default.unbind(el, type, cb, capture);
    callback.call(this, arguments);
  };
  _event2.default.bind(el, type, cb, capture);
};

var _event = require('event');

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./~/once-event/dest/index.js
 ** module id = 516
 ** module chunks = 0
 **/